// TODO(cyrille): Export other constants from here.
// eslint-disable-next-line import/prefer-default-export
export const SELECTION_SECTION = 'selection'
